import { useTranslation } from 'react-i18next';
import { ReactComponent as ArrowRightIcon } from 'assets/icons/arrow-right.svg';
import Button from 'components/Button/Button';
import EmptyTaskManagement from 'components/EmptyTaskManagement/EmptyTaskManagement';
import StepItem from 'components/StepItem/StepItem';
import TitleTableWrapper from 'components/TitleTableWrapper/TitleTableWrapper';
import TitleWrapper from 'components/TitleWrapper/TitleWrapper';
import { DATA_SETS_SUPPLIERS_STAKEHOLDERS_HEAD_CELLS } from 'constants/dataSets';
import { BUTTON_VARIANT } from 'constants/interfaces';

import CreateSupplierModal from './components/CreateSupplierModal/CreateSupplierModal';
import SupplierListModal from './components/SupplierListModal/SupplierListModal';
import SuppliersTable from './components/SuppliersTable/SuppliersTable';

import type IMaterialityAssessmentSupplier from './interfaces/IMaterialityAssessmentSupplier';

import styles from './scss/MaterialityAssessmentSupplier.module.scss';

function MaterialityAssessmentSupplierView({
  isEmptyList, loading, goToNextMaterialityAssessment, goBack, addStakeholder,
  isOpenModal, addSuppliers, closeModal, selectedItems, setSelectedItems,
  onOpenCreateModal, isCreateModalOpen, vcSuppliers,
  suppliersList, isEmptyMainList, onDeleteItem, hasMore, loadMoreSuppliers, naceCodeTreeData,
  search, onSearchChange, setUnSelectedItems, vcmName, loadMoreVCSuppliers,
  hasMoreVCSuppliers, isViewOnly = false,
}:IMaterialityAssessmentSupplier) {
  const { t } = useTranslation();

  return (
    <div className={styles.root}>
      <span className={styles.header}>{t('materialityAssessment.titleStakeholder', { vcmName })}</span>
      <div className={styles.rootContainer}>
        <div className={styles.wrapper}>
          <TitleWrapper
            description={t('materialityAssessment.titleStakeholderDescription')}
          />

          <div className={styles.stepStakeholder}>
            <StepItem title={t('materialityAssessment.titleStepStakeholder')} step={1} done />
            <ArrowRightIcon />
            <StepItem title={t('materialityAssessment.titleSecondStepStakeholder')} step={2} />
          </div>
          <TitleTableWrapper
            title={t('materialityAssessment.importantSuppliers')}
            buttonTitle={t('materialityAssessment.addSupplier')}
            onButtonClick={addStakeholder}
            showButton={!isEmptyMainList && !isViewOnly}
            buttonClassName={styles.button}
            prevTitleBtn={isViewOnly ? undefined : t('materialityAssessment.createNewSupplier')}
            onBtnClickPrev={isViewOnly ? undefined : onOpenCreateModal}
            disableButton={isViewOnly}
          />
          <div className={styles.contentWrapper}>
            {isEmptyMainList && !loading ? (
              <EmptyTaskManagement
                title={t('materialityAssessment.emptySupplierDescription')}
                buttonTitle={t('materialityAssessment.addStakeholder')}
                buttonOnClick={addStakeholder}
                disabledButton={isViewOnly}
              />
            ) : (
              <div className={styles.tableWrapper}>
                <SuppliersTable
                  items={suppliersList}
                  headerCells={DATA_SETS_SUPPLIERS_STAKEHOLDERS_HEAD_CELLS}
                  onDeleteItem={onDeleteItem}
                  loadMoreSuppliers={loadMoreSuppliers}
                  naceCodeTreeData={naceCodeTreeData}
                  hasMore={hasMore}
                  isActionsVisible={!isViewOnly}
                  isInfoTable
                />
              </div>
            )}
          </div>
        </div>
        <div className={styles.buttonWrapper}>
          <Button
            title={t('common.cancel')}
            variant={BUTTON_VARIANT.cancel}
            className={styles.button}
            onClick={goBack}
          />
          <Button
            title={t('common.next')}
            onClick={goToNextMaterialityAssessment}
            className={styles.button}
          />
        </div>
      </div>
      <SupplierListModal
        open={isOpenModal}
        onClose={closeModal}
        title={t('materialityAssessment.selectImportantSuppliers')}
        onConfirm={addSuppliers}
        isLoading={loading}
        isEmptyList={isEmptyList}
        selectedItems={selectedItems}
        setSelectedItems={setSelectedItems}
        vcSuppliers={vcSuppliers || []}
        search={search}
        onSearchChange={onSearchChange}
        setUnSelectedItems={setUnSelectedItems}
        loadMoreVCSuppliers={loadMoreVCSuppliers}
        hasMoreVCSuppliers={hasMoreVCSuppliers}
      />

      <CreateSupplierModal
        open={isCreateModalOpen}
        onClose={onOpenCreateModal}
        title={t('materialityAssessment.createNewImportantSupplier')}
      />
    </div>
  );
}

export default MaterialityAssessmentSupplierView;
